import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/services/data.service";
import { NotificationService } from "../../core/services/notification.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class CachesService extends DataService<number, number> {
    
    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'caches';
    }

    refreshRequestEngineerCache(requestId: number): Observable<any> {
        return this.postQuery(`${this.baseUrl()}/refresh-request-persons-stock`, { requestId: requestId });
    }
}